module.exports = __webpack_public_path__ + "static/media/lot.11895508.jpg";